import React from 'react';
import SwaggerUI from 'swagger-ui-react';

import 'swagger-ui-react/swagger-ui.css';

export const IntegrationDocs = ({ isAuthenticated }) => {
  const requestInterceptor = req => {
    let authToken = localStorage.getItem('app-authenticationToken') || sessionStorage.getItem('app-authenticationToken');
    if (authToken) {
      authToken = JSON.parse(authToken);
      req.headers['Authorization'] = 'Bearer ' + authToken;
    } else {
      req.headers.Authorization = 'Bearer ' + req.headers.Authorization;
    }
    return req;
  };

  const HideInfoUrlPartsPlugin = () => ({
    wrapComponents: {
      InfoUrl: () => () => null,
      Servers: () => () => null,
    },
  });

  return (
    <div style={{ marginLeft: '80px' }}>
      {!isAuthenticated && (
        <a href="/">
          <img src="../content/images/logomarca-sigaway-dark.png" alt="Logo da Empresa" width="250px" style={{ padding: '30px' }} />
        </a>
      )}
      <SwaggerUI
        defaultModelsExpandDepth={3}
        defaultModelExpandDepth={3}
        url="/v3/api-docs?group=integration"
        requestInterceptor={requestInterceptor}
        plugins={[HideInfoUrlPartsPlugin]}
      />
    </div>
  );
};
